import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Common from '../../../Common/Common';
import HelpSite from "../../../Common/HelpLink";
import ReportService from '../../../Dashboard/Controller/ReportController';
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import Draggable from 'react-draggable';
import InputParameters from '../../../Dashboard/View/InputModal';
import OutputParameters from '../../../Dashboard/View/OutputParameters';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import axiosInstance from '../../../../config/axiosInstance';
function StockReportPage({ ClientCompanyID }) {
    const HelpLink = localStorage.getItem('HelpLink');
    const navigate = useNavigate();
    const [reports, setReports] = useState([]);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [ModuleList, setModuleList] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [inputValues, setInputValues] = useState({});
    const [outputData, setOutputData] = useState([]);
    const [outputParam, setOutputParam] = useState([]);
    const [error, setError] = useState(null);
    const { theme } = useContext(ThemeContext);
    const [showInputModal, setShowInputModal] = useState(false);
    const [showOutputModal, setShowOutputModal] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false); // State to control PDF modal visibility
    const [imageData, setImageData] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [selectedRowId, setSelectedRowId] = useState(null);
    useEffect(() => {
        fetchReports(18);
        // Retrieve ClientID from session storage and add it to inputValues
        const clientID = sessionStorage.getItem('ClientID');
        if (clientID) {
            setInputValues((prevValues) => ({ ...prevValues, ClientID: clientID }));
        }
    }, []);

    const fetchReports = async (moduleID) => {
        try {
            const data = await JasperReportService.GetAllJasperReports(moduleID);
            setReports(data);
        } catch (err) {
            setError('Failed to load reports');
            console.error(err);
        }
    };
    const handleReportSelect = async (reportId) => {
        try {
            debugger;
            setSelectedRowId(reportId);
            const details = await JasperReportService.getReportDetail(reportId);
            setSelectedReport(details);

            // Reset inputValues and add ClientID
            const clientID = localStorage.getItem('CompanyID');
            setInputValues(clientID ? { ClientID: clientID } : {});

            setOutputData([]);
            setOutputParam([]);

            // Show output modal directly if no input parameters are required
            if (details.inputParams[0].length === 0) {
                //setSelectedReport(reportId);
                await handleExecuteReport();
            } else {
                setShowInputModal(true); // Show the input modal if input parameters exist
            }
        } catch (err) {
            setError('Failed to load report details');
            console.error(err);
        }
    };

    const handleModuleSelect = async (moduleID) => {
        await fetchReports(moduleID);
    };

    const handleInputChange = (param, value) => {
        setInputValues((prevValues) => ({ ...prevValues, [param]: value }));
    };

  const handleExecuteReport = async () => {
    try {
        const JasperReport = await JasperReportService.GetJasperReportByID(selectedRowId);
        let url = JasperReport[0].Link;
        setReportLink(url);
        setReportTitle(JasperReport[0].ReportTitle);

        // Replace placeholders {ClientID}, {UserID} dynamically
        const replacedKeys = {};
        Object.keys(inputValues).forEach((key) => {
            const placeholder = new RegExp(`{${key}}`, 'g');
            let value = inputValues[key];

            if (key === "ClientID") {
                value = localStorage.getItem("CompanyID");
            } else if (key === "UserID") {
                value = localStorage.getItem("UserID");
            }

            if (url.includes(`{${key}}`)) {
                url = url.replace(placeholder, value);
                replacedKeys[key] = true;
            }
        });

        // ✅ Build query object including *all* params
        const queryObj = {
            ...inputValues,
            format: 'pdf',
            ReportName: JasperReport[0].ReportName,
            ReportType: JasperReport[0].ReportType,
            name: JasperReport[0].ReportName
        };

        // ✅ Remove only ClientID and UserID if they exist
    

        // ✅ Convert to query string
        const queryString = new URLSearchParams(queryObj).toString();

        // ✅ Call proxy endpoint with query string
        const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
            responseType: 'blob' // important for PDF
        });

        // ✅ Convert Blob to Object URL
        const pdfObjectUrl = URL.createObjectURL(response.data);

        setPdfUrl(pdfObjectUrl);
        setShowPdfModal(true);
        setShowInputModal(false);
        setShowOutputModal(false);

    } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
    }
};




    const generatePDF = (reportTitle, additionalInfo, imageData, outputParams, outputData) => {
        debugger;
        const doc = new jsPDF();
        const currentDate = new Date().toLocaleDateString();

        // Header Section with Company Information
        doc.setFontSize(10);
        doc.setLineWidth(0.3);
        doc.rect(10, 10, 190, 30);

        if (additionalInfo) {
            const lines = additionalInfo.split('\n');
            lines.forEach((line, index) => {
                doc.text(line, 14, 16 + (index * 4)); // Company info lines
            });
        }

        if (imageData) {
            doc.addImage(imageData, 'PNG', 150, 16, 40, 20); // Logo placement
        }

        // Title Section
        doc.rect(10, 45, 190, 12);
        doc.setFontSize(12);
        doc.text(reportTitle, doc.internal.pageSize.width / 2, 52, { align: 'center' });

        // Table Section
        doc.rect(10, 60, 190, doc.internal.pageSize.height - 80);
        const headers = outputParams.map((param) => param.DisplayName);

        const data = outputData.map((row) =>
            outputParams.map((param) => {
                const value = row[param.ColumnName] || "";
                if (typeof value === "string" && value.includes("T")) {
                    const date = new Date(value);
                    return isNaN(date) ? value : date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
                }
                return value;
            })
        );

        const totalPagesExp = "{total_pages_count_string}";

        doc.autoTable({
            startY: 65,
            head: [headers],
            body: data,
            theme: "grid",
            styles: {
                fontSize: 8,
                cellPadding: 2,
                halign: "center",
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: 255,
                fontSize: 9,
                fontStyle: "bold",
            },
            margin: { bottom: 30 },
            didDrawPage: (data) => {
                const pageNumber = doc.internal.getNumberOfPages();
                const footerText = `Page ${pageNumber} of ${totalPagesExp}`;
                doc.setFontSize(8);
                doc.text(`${currentDate}`, 10, doc.internal.pageSize.height - 10);
                doc.text(footerText, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
            },
        });

        if (typeof doc.putTotalPages === "function") {
            doc.putTotalPages(totalPagesExp);
        }

        const pdfBlob = doc.output("blob");
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url); // Store the URL in state
        setShowPdfModal(true); // Show the PDF modal
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            const response = await fetch('assets/img/resources/trent.PNG');
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageData(reader.result); // base64 data
            };
            reader.readAsDataURL(blob);
        };

        loadImage();
    }, []);
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Report" Module="3" />
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px" }}>
                <table className="table m-0 table-hover table-bordered">
                    <thead>
                        <tr><th>Report File</th></tr>
                    </thead>
                    <tbody>
                        {reports.map((report) => (
                            <tr key={report.ID}
                                onClick={() => handleReportSelect(report.ID)}
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: report.ID === selectedRowId ? '#d3f9d8' : 'white', // Highlight selected row
                                }}>
                                <td>{report.ReportTitle}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {showInputModal && (
                <InputParameters
                    inputParams={selectedReport.inputParams[0]}
                    inputValues={inputValues}
                    onInputChange={handleInputChange}
                    onExecuteReport={handleExecuteReport}
                    onClose={() => setShowInputModal(false)}
                />
            )}

            {/* Output Parameters Modal */}
            {showOutputModal && (
                <OutputParameters
                    outputData={outputData}
                    outputParams={outputParam}
                    onClose={() => setShowOutputModal(false)}
                    companyInfo="Sam Software Solution Ltd\n46-48 Alfreton Road\nCanning Circus\nNottingham, NOTT\nNG7 3NN"
                    inputValues={inputValues}                   // ✅ NEW
                    reportLink={reportLink || ""}     // ✅ NEW
                    reportTitle={reportTitle || "Report"}
                />
            )}
        </div>
    );
}

export default StockReportPage;
